// Utilitário para checar se há uma nova versão do app
const VERSION_KEY = 'app_version';
const VERSION_URL = '/meta.json'; // arquivo gerado no build

export async function checkForNewVersion(): Promise<boolean> {
	try {
		const res = await fetch(VERSION_URL, { cache: 'no-store' });
		if (!res.ok) {
			console.warn('Failed to fetch version info:', res.statusText);
			return false;
		}

		const { version } = await res.json();
		const current = localStorage.getItem(VERSION_KEY);

		// If no version is stored, this is the first load - store it and don't prompt for update
		if (!current) {
			localStorage.setItem(VERSION_KEY, version);
			return false;
		}

		if (current !== version) {
			localStorage.setItem(VERSION_KEY, version);
			return true;
		}
		return false;
	} catch (error) {
		console.error('Error checking for new version:', error);
		return false;
	}
}

export function updateStoredVersion(version: string) {
	localStorage.setItem(VERSION_KEY, version);
}
